export default String.raw`
.products-list{
    &__list-view-product{
        display: flex;
        position: relative;
        gap: 15px;
        margin-bottom: 50px;
        padding: 16px;
        transition: 0.5s all ease;

        .image-container{
            width: 25%;
            overflow: hidden;
            &__wrapper{
                width: 100%;
                height: 365px;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                    position: absolute;
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                    border-radius: 4px;
                }
                .no-image {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 100%;
                    height: 100%;
                    max-width: 120px;
                    max-height: 120px;
                    transform: translate(-50%, -50%);
                    object-fit: contain;
                    fill: #D5D5D5;
                }
            }
            &__flags{
                position: absolute;
                top: 15px;
                left: 0px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 2px;
            }
            .product-item__phantom {
                margin-top: 8px;
                bottom: 0;
                width: 100%;
                min-height: 71px;
                visibility: hidden;
                background: #fff;
                transition: transform 0.5s ease, visibility 0.5s ease;
                transform: translateY(100%);
                user-select: none;
                position: absolute;
                z-index: 2;

                .on-label {
                    width: 100%;
                    top: -20px;
                    background: #fff;
                    padding: 16px 0 8px 0;
                    left: 0;
                    @include body-2-regular;
                    color: #767676;
                }

                ul {
                    right: 0px;
                    top: 47px;
                    max-height: 150px;
                    padding: 10px 8px 10px 16px;
                    display: none;
                    position: absolute;
                    z-index: 3;
                    overflow: auto;
                    background-color: #fff;
                    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);
                    li {
                        padding: 6px 0px;
                        a {
                            color: $primaryColorFont;
                        }
                        a:hover {
                            color: $hoverOverButton;
                        }
                    }
                }
                &--select {
                    border-radius: 5px;
                    border: 1px solid #2E2E2E;
                    padding: 10px 8px 10px 16px;
                    &-active {
                        user-select: none;
                    }
                    svg {
                        width: 15px;
                        height: 15px;
                        fill: $primaryColor;
                    }
                }

                &-first {
                    display: flex;
                    width: 100%;
                    justify-content: flex-start;
                    flex-direction: row;

                    .more-items{
                        display: flex;
                        width: 40px;
                        height: 40px;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .withPhotos {
                    padding: 10px 0 0 0 !important;
                }

                &-second {
                    min-height: 30px;
                    display: block;
                    width: 100%;
                    margin-bottom: 15px;
                }

                &-image {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #e6e6e6;
                    margin-right: 4px;
                    min-width: fit-content;
                    border-radius: 4px;
                    a {
                        width: 40px;
                        height: 40px;
                        display: flex;
                        object-fit: contain;
                        align-items: center;
                        justify-content: center;
                    }

                    &-last {
                        margin-right: 0;
                    }
                    &:hover {
                        border: 1px solid $primaryColor;
                        cursor: pointer;
                    }
                }

                &-img, .svgIcon {
                    max-width: 40px;
                    max-height: 40px;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 4px;
                }

                &-more {
                    width: 50px;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    background-color: $bgColor;
                    margin-right: 0;
                    font-size: 16px;
                    line-height: 1.5;
                    letter-spacing: 1.2px;
                }

                &-active {
                    border: 1px solid $primaryColor;
                }

                &-attributes {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    overflow-x: hidden;
                }

                &-secondAttribute {
                    text-align: center;
                    padding: 0 8px;
                    font-size: 14px;
                    letter-spacing: 1.2px;
                    line-height: 1.71;
                    color: $primaryColor;
                    border: 1px solid #e6e6e6;
                    margin-right: 15px;
                    transition: 200ms;
                    &-last {
                        margin-right: 0;
                    }
                    &:hover {
                        color: $primaryColor;
                        border: 1px solid $primaryColor;
                    }
                }

                &-withColors {
                    .product-item__phantom-first {
                        padding: 10px 10px 0;
                        div {
                            a {
                                border-radius: 50%;
                            }
                        }
                    }

                    .more-items {
                        display: flex;
                        width: 22px;
                        height: 22px;
                        align-items: center;
                        justify-content: center;
                    }
                }

                &-colorWrapper {
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    margin-right: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid $bgColor;
                    &:hover {
                        border: 1px solid $primaryColor;
                        cursor: pointer;
                    }
                }

                &-color {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                }
                .border {
                    border: 1px solid;
                }
            }
            .visiblePhantomContainer{
                transform: translateY(0);
                visibility: visible;
            }
            .visiblePhantomContainerImportant{
                visibility: hidden !important;
            }
        }
        .content-and-quantity-container{
            display: flex;
            width: 75%;
            gap: 15px;
        }
        .content-container {
            width: 50%;

            &__name {
                @include h3-headline;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin-bottom: 16px;

                a {
                    outline-offset: -1px !important;
                }
            }

            &__attributes {
                position: relative;
                display: -webkit-box;
                -webkit-line-clamp: 7;
                height: auto;
                -webkit-box-orient: vertical;
                overflow: clip;
                transition: all 500ms ease;
                overflow-wrap: break-word;
                line-height: 20px;
            }

            .description {
                @include body-1-regular;
            }

            .attribute {
                margin-bottom: 8px;
                line-height: normal;

                &__name{
                    @include body-1-regular;
                }

                &__value{
                    @include body-1-semi-bold;
                }

                svg {
                    // Centers the icon
                    position: relative;
                    z-index: 2;
                    vertical-align: sub;
                    margin-left: 4px;
                    cursor: pointer;
                    fill: $primaryColor;
                    pointer-events: all;
                }
            }
            .see-more-checkbox, .less{
                display: none;
            }

            .see-more {
                &__button{
                    position: sticky;
                    z-index: 2;
                    display: inline;
                    margin-top: 20px;
                    background-color: transparent;
                    cursor: pointer;
                    @include button;
                    color: $primaryColor;
                }
                &__icon{
                    width: 15px;
                    height: 15px;
                    vertical-align: middle;
                    fill: $primaryColor;
                    transition: all 500ms ease;
                }
            }
            .see-more-checkbox:checked + .content-container__attributes {
                max-height: 30lh;
                -webkit-line-clamp: unset;
                

            }

            .see-more-checkbox:checked + .content-container__attributes + label {
                .more{
                    display: none;
                }
                .less{
                    display: inline;
                }
                .see-more__icon{
                    transform: rotate(180deg);
                }
            }
        }
        .quantity-container{
            width: 45%;
            &__login-to-see-prices{
                display: flex;
                align-items: center;
                gap: 10px;
                .icon{
                    width: 19px;
                    height: 19px;
                }
                .info{
                    font-size: 14px; 
                    line-height: 20px; 
                }
            }
            &__suggested {
                @include body-2-regular;
                padding-top: 16px;
                color: #767676;
            }
            &__label{
                color: #767676;
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 5px;
            }
            &__range{
                font-size: 14px; 
                line-height: 20px; 
            }
            &__open-thresholds-popup{
                position: relative;
                z-index: 2;
                color: #2E2E2E;
                font-weight: 400;
                text-decoration: underline;
                padding: 0;
                margin-top: 5px !important;
                font-size: 14px; 
                line-height: 20px; 
            }
            &__price-container, &__deposit-price-container{
                display: flex;
                gap: 8px;
                align-items: center;
                margin-bottom: 5px;
                .deposit{
                    font-size: 12px;
                    line-height: 18px;
                    color: #767676;
                }
                .price{
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                }
                .previous{
                    font-size: 12px;
                    line-height: 18px;
                    color: #767676;
                    text-decoration: line-through;
                }
                .label{
                    font-size: 14px; 
                    line-height: 20px; 
                    margin: 0;
                }
            }
            &__unit-price{
                font-size: 12px;
                line-height: 16px;
                color: #767676;
                margin-top: 5px;
            }
            &__lowest-price{
                font-size: 12px;
                line-height: 16px;
                color: #767676;
                margin-top: 5px;
            }
            &__availability-container{
                font-size: 12px;
                line-height: 16px;
                margin-top: 10px;
                .availability{
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
                img{
                    max-height: 16px;
                }
            }
            &__stock-container{
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 10px;
                img{
                    max-height: 16px;
                    margin-top: 10px;
                }
                .stock{
                    margin-top: 10px;
                }
            }
            .quantity{
                position: relative;
                border: 1px solid #767676;
                border-radius: 5px;
                background: $inputsBgColor;
                display: inline-flex;
                width: 107px;
                height: 40px;
                padding: 10px;
                margin-top: 15px;
                z-index: 2;
                &.validation-error {
                    border-color: $dangerColor;
                    input {
                        color: $dangerColor;
                    }
                }
                &__input{
                    font-size: 14px; 
                    line-height: 20px;
                    background: transparent; 
                    border: none;
                    width: 49px;
                    height: 18px;
                    text-align: center;
                }
                &__minus, &__plus{
                    border: none;
                    background: transparent;
                    width: 18px;
                    padding: 0;
                    .icon{
                        width: 11px;
                        height: 11px;
                        fill: #959595;
                    }
                }
            }
            .unit{
                margin-left: 5px;
            }
            .primary-buttons{
                display: flex;
                gap: 10px;
                position: relative;

                .more-options-mobile {
                    display: none;
                    z-index: 3;
                    &__items {
                        position: absolute;
                        top: 66px;
                        right: 0;
                        z-index: 3;
                        width: max-content;
                        background-color: $bgColor;
                        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
                        border-radius: 5px;
                        text-align: left;
                        li {
                            padding: 10px 16px;
                            cursor: pointer;
                            &:hover, &:active, &.focused-option-js {
                                background-color: rgba(147, 67, 70, 0.1);
                                color: $primaryColor;
                            }
                        }
                    }
                }
            }
            .primary-action-button{
                display: inline-flex;
                position: relative;
                gap: 5px;
                width: 100%;
                justify-content: center;
                margin: 15px 0 10px;
                z-index: 2;
                &.with-wishlist{
                    width: calc(100% - 50px);
                }
                &__text{
                    font-weight: 600;
                    line-height: 20px;
                }
                &__icon{
                    width: 21px;
                    height: 19px;
                }
            }
            .pure-button{
                display: inline-flex;
                gap: 5px;
                margin: 15px 0 10px;
                padding: 0;
                &__text{
                    font-weight: 600;
                    line-height: 20px;
                }
                &__icon{
                    width: 21px;
                    height: 19px;
                }
            }
            .secondary-buttons{
                display: flex;
                position: relative;
                z-index: 2;
                gap: 8px;

                &:has(.secondary-action-button + .secondary-action-button) .secondary-action-button {
                    width: calc(50% - 4px);
                }
            }
            .secondary-action-button{
                width: 100%;
                &.wishlist, &.actions {
                    width: 40px;
                    margin: 15px 0 10px;
                    padding: 0;
                    z-index: 2;
                }
                &.actions {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                }
                &__icon{
                    fill: $primaryColor;
                    width: 24px;
                    height: 24px;
                    flex-shrink: 0;
                }
                &.sign-in {
                    width: 100%;
                }
            }
        }
        &--product-container-link{
            position: absolute;
            width: 100%;
            height: 100%;
            background: inherit;
            z-index: 1;
            bottom: 0;
            left: 0;
        }
    }
    &__list-view-product:hover{
        border-radius: 12px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);
    }
    &__quick-shopping-view-product{
        display: flex;
        position: relative;
        gap: 2%;
        padding: 16px;
        border-bottom: 1px solid #E7E7E7;
        align-items: baseline;
        &:last-child{
            padding-bottom: 0;
            border: none;
            margin-bottom: 0;
        }
        .content-container{
            width: calc(100% - 4% - 460px);
            &__name{
                font-size: 14px; 
                line-height: 20px; 
                font-weight: 500;
            }
            &__attributes{
                font-size: 12px;
                line-height: 16px;
                font-weight: 500;
                margin-top: 5px;
                .separator{
                    color: #E8E8E8;
                    margin: 0 4px;
                    font-size: 20px;
                    font-weight: 100;
                    vertical-align: text-bottom;
                }
            }
        }
        .prices-container{
            width: 230px;
            &__label{
                color: #767676;
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 5px;
            }
            &__range{
                font-size: 14px; 
                line-height: 20px; 
            }
            &__open-thresholds-popup{
                position: relative;
                z-index: 2;
                color: #2E2E2E;
                font-weight: 400;
                text-decoration: underline;
                padding: 0;
                margin-top: 5px;
                font-size: 14px; 
                line-height: 20px; 
            }
            &__price-container, &__deposit-price-container{
                display: flex;
                gap: 4px;
                align-items: center;
                margin-bottom: 5px;
                .deposit{
                    font-size: 12px;
                    line-height: 18px;
                    color: #767676;
                }
                .price{
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 20px;
                }
                .previous{
                    font-size: 12px;
                    line-height: 18px;
                    color: #767676;
                    text-decoration: line-through;
                }
                .label{
                    font-size: 14px; 
                    line-height: 20px; 
                }
            }
            &__suggested {
                @include body-2-regular;
                color: #767676;
                padding: 16px 0 6px;
            }
            &__lowest-price{
                font-size: 10px;
                font-weight: 500;
                line-height: 15px;
                color: #767676;
                margin-top: 5px;
            }
        }
        .quantity-container{
            width: 230px;
            &__availability-container{
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 10px;
                .availability{
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
                img{
                    max-height: 16px;
                }
            }
            &__stock-container{
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                line-height: 16px;
                img{
                    max-height: 16px;
                    margin-bottom: 10px;
                }
                .stock{
                    margin-bottom: 10px;
                }
            }
            .quantity{
                position: relative;
                border: 1px solid #767676;
                background: $inputsBgColor;
                border-radius: 5px;
                display: inline-flex;
                width: 91px;
                height: 40px;
                padding: 10px;
                z-index: 2;
                &__input{
                    background: transparent;
                    font-size: 14px; 
                    line-height: 20px; 
                    border: none;
                    width: 49px;
                    height: 18px;
                    text-align: center;
                }
                &__minus, &__plus{
                    border: none;
                    background: transparent;
                    width: 18px;
                    padding: 0;
                    .icon{
                        width: 11px;
                        height: 11px;
                        fill: #959595;
                    }
                }
            }
            &__unit{
                margin-left: 5px;
            }
            .primary-action-button, .secondary-action-button, .pure-button{
                display: inline-flex;
                gap: 5px;
                align-items: center;
                &__text{
                    font-weight: 600;
                    line-height: 20px;
                }
                &__icon{
                    width: 21px;
                    height: 19px;
                }
            }
            .primary-action-button, .secondary-action-button{
                width: 230px;
                padding: 8px 30px;
                position: relative;
                z-index: 2;
            }
            .secondary-action-button{
                fill: $primaryColor;
            }
            .pure-button{
                padding: 0;
            }
        }
    }
    &__grid-view-product{
        transition: 0.5s all ease;
        width: calc((100% - 50px) / 3);
        padding: 16px;
        position: relative;
        cursor: pointer;

        .image-container{
            width: 100%;
            position: relative;
            overflow: hidden;
            height: 345px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &__flags{
                position: absolute;
                top: 15px;
                left: 0px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 2px;
            }
            img {
                position: absolute;
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
                border-radius: 4px;
            }
            .no-image {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                max-width: 160px;
                max-height: 160px;
                transform: translate(-50%, -50%);
                object-fit: contain;
                fill: #D5D5D5;
            }
            .product-item__phantom {
                position: absolute;
                bottom: 0;
                width: 100%;
                min-height: 71px;
                padding: 8px 0 0 0;
                visibility: hidden;
                background: #fff;
                transition: transform 0.5s ease, visibility 0.5s ease;
                transform: translateY(100%);
                user-select: none;
                z-index: 2;

                ul {
                    right: 0px;
                    top: 57px;
                    max-height: 150px;
                    padding: 10px 8px 10px 16px;
                    display: none;
                    position: absolute;
                    z-index: 9999;
                    overflow: auto;
                    background-color: #fff;
                    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);

                    li {
                        padding: 6px 0px;
                        a {
                            color: $primaryColorFont;
                        }
                        a:hover {
                            color: $hoverOverButton;
                        }
                    }
                }
                &--select {
                    border-radius: 5px;
                    border: 1px solid #2E2E2E;
                    padding: 10px 8px 10px 16px;
                    &-active {
                        user-select: none;
                    }
                    svg {
                        width: 15px;
                        height: 15px;
                        fill: $primaryColor;
                    }
                }

                &-first {
                    display: flex;
                    width: 100%;
                    justify-content: flex-start;
                    flex-direction: row;

                    .more-items{
                        display: flex;
                        width: 40px;
                        height: 40px;
                        align-items: center;
                        justify-content: center;
                    }
                }

                &-second {
                    min-height: 30px;
                    display: block;
                    width: 100%;
                    margin-bottom: 15px;
                }

                &-image {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #e6e6e6;
                    margin-right: 4px;
                    min-width: fit-content;
                    border-radius: 4px;
                    a {
                        width: 40px;
                        height: 40px;
                        display: flex;
                        object-fit: contain;
                        align-items: center;
                        justify-content: center;
                    }

                    &-last {
                        margin-right: 0;
                    }
                    &:hover {
                        border: 1px solid $primaryColor;
                        cursor: pointer;
                    }
                }

                &-img, .svgIcon {
                    max-width: 40px;
                    max-height: 40px;
                    display: block;
                    height: auto;
                    width: auto;
                    position: unset;
                    object-fit: unset;
                }

                &-more {
                    width: 50px;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    background-color: $bgColor;
                    margin-right: 0;
                    font-size: 16px;
                    line-height: 1.5;
                    letter-spacing: 1.2px;
                }

                &-active {
                    border: 1px solid $primaryColor;
                }

                &-attributes {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    overflow-x: hidden;
                }

                &-secondAttribute {
                    text-align: center;
                    padding: 0 8px;
                    font-size: 14px;
                    letter-spacing: 1.2px;
                    line-height: 1.71;
                    color: $primaryColor;
                    border: 1px solid #e6e6e6;
                    margin-right: 15px;
                    transition: 200ms;
                    &-last {
                        margin-right: 0;
                    }
                    &:hover {
                        color: $primaryColor;
                        border: 1px solid $primaryColor;
                    }
                }

                &-withColors {
                    .product-item__phantom-first {
                        padding: 10px 10px 0;
                        div {
                            a {
                                border-radius: 50%;
                            }
                        }
                    }

                    .more-items {
                        display: flex;
                        width: 22px;
                        height: 22px;
                        align-items: center;
                        justify-content: center;
                    }
                }

                &-colorWrapper {
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    margin-right: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &:hover {
                        border: 1px solid $primaryColor;
                        border-radius: 5px;
                        cursor: pointer;
                    }
                }

                &-color {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    border: 1px solid;
                }
            }
            .visiblePhantomContainer{
                transform: translateY(0);
                visibility: visible;
            }
            .visiblePhantomContainerImportant{
                visibility: hidden !important;
            }
        }
        .content-container{
            padding-top: 16px;
            &__code{
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            &__name{
                font-size: 14px;
                line-height: 20px; 
                height: 40px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin-bottom: 15px;

                a {
                    outline-offset: -1px !important;
                }
            }
            &__login-to-see-prices{
                display: flex;
                align-items: center;
                gap: 10px;
                .icon{
                    width: 19px;
                    height: 19px;
                }
                .info{
                    font-size: 14px; 
                    line-height: 20px; 
                }
            }
            &__label{
                color: #767676;
                font-size: 12px;
                line-height: 16px;
            }
            &__range{
                font-size: 14px; 
                line-height: 20px; 
            }
            &__open-thresholds-popup{
                position: relative;
                z-index: 2;
                color: #2E2E2E;
                font-weight: 400;
                text-decoration: underline;
                padding: 0;
                margin-top: 5px;
                line-height: 17px !important;
                font-size: 14px; 
            }
            &__price-container, &__deposit-price-container{
                display: flex;
                gap: 8px;
                align-items: center;
                padding-bottom: 5px;
                height: 25px;

                .deposit{
                    font-size: 12px;
                    line-height: 18px;
                    color: #767676;
                }
                .price{
                    font-size: 14px; 
                    line-height: 20px; 
                    font-weight: 600;
                }
                .previous{
                    font-size: 12px;
                    line-height: 18px;
                    color: #767676;
                    text-decoration: line-through;
                }
                .label{
                    font-size: 14px; 
                    line-height: 20px; 
                    margin: 0;
                }
            }
            &__unit-price{
                font-size: 12px;
                line-height: 16px;
                color: #767676;
                height: 32px;
            }
            &__lowest-price{
                font-size: 12px;
                line-height: 16px;
                height: 32px;
                color: #767676;
            }
            &__suggested {
                @include body-2-regular;
                padding-top: 16px;
                height: 32px;
                color: #767676;
            }
        }
        .buttons{
            .primary-buttons{
                display: flex;
                gap: 10px;
            }
            .primary-action-button{
                position: relative;
                width: 100%;
                height: 40px;
                display: flex;
                gap: 5px;
                margin-top: 15px;
                justify-content: center;
                z-index: 2;
                &.with-wishlist{
                    width: calc(100% - 50px);
                }
                &__text{
                    text-align: center;
                    font-weight: 600;
                    font-size: 14px; 
                    line-height: 20px; 
                }
                &__icon{
                    width: 21px;
                    height: 19px;
                }
            }
            .secondary-action-button{
                width: 40px;
                margin: 15px 0 10px;
                padding: 0;
                z-index: 2;
                &__icon{
                    fill: $primaryColor;
                    width: 24px;
                    height: 24px;
                }
            }
            & > .secondary-action-button{
                width: 100%;
            }
        }
    }
    &__grid-view-product:hover{
        border-radius: 12px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);
    }
    .open360{
        z-index: 2;
        width: 40px;
        height: 40px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.60);
        right: auto;
        top: auto;
        left: 10px;
        bottom: 10px;
        padding: 5px;
        svg {
            width: 100%;
            height: 100%;
        }
    }
    .min-quantity-info {
        display: flex;
        column-gap: 8px;
        margin-top: 16px;
        @include body-2-regular;

        svg {
            min-height: 20px;
            min-width: 20px;
            width: 20px;
            height: 20px;
            fill: $warnColor;
        }
    }
}

ul.product-item__phantom-first {
        right: 0px;
        top: 57px;
        max-height: 150px;
        padding: 10px 8px 10px 16px;
        display: none;
        position: absolute;
        z-index: 9999;
        overflow: auto;
        background-color: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);

        li {
            padding: 6px 0px;
            a {
                color: $primaryColorFont;
            }
            a:hover {
                color: $hoverOverButton;
            }
        }
        &--select {
            border-radius: 5px;
            border: 1px solid #2E2E2E;
            padding: 10px 8px 10px 16px;
            &-active {
                user-select: none;
            }
            svg {
                width: 15px;
                height: 15px;
                fill: $primaryColor;
            }
    }
}
    

.ribbon {
    font-size: 10px;
    font-weight: 500;
    line-height: 15px;
    color: $ribbonTextColor;
    padding: 1px 8px;
    border-radius: 2px;
    &.archival {
        background: #D5D5D5;
    }
    &.Promotion, &.free {
        background: $ribbonPromotion;
    }
    &.BestRated {
        background: $ribbonBestRated;
    }
    &.NewProduct {
        background: $ribbonNewProduct;
    }
    &.RecommendedProduct {
        background: $ribbonRecommendedProduct;
    }
    &.PromotionalProduct {
        background: $ribbonPromotionalProduct;
    }
    &.VendorRecomendation {
        background: $ribbonVendorRecomendation;
    }
    &.GreatPrice {
        background: $ribbonGreatPrice;
    }
    &.GreatQuality {
        background: $ribbonGreatQuality;
    }
    &.Sale {
        background: $ribbonSale;
    }
    &.Reward {
        background: $ribbonReward;
    }
}
`